import { FC } from 'react';
import { Avatar, AvatarProps } from './Avatar';

type Props = {
  avatarProps?: AvatarProps;
  isHidden?: boolean;
};

export const StudiesHeaderNavToolsBox: FC<Props> = ({ avatarProps, isHidden = false }) => {
  if (isHidden) {
    return null;
  } else {
    return <Avatar {...avatarProps} />;
  }
};
